
import React from 'react'
import icon from './svgs/WalletMoney.svg'
import { BaseIcon } from './_base'

export const WalletMoneyIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
